import { render } from "./setPeppol.vue?vue&type=template&id=eda8ecce"
import script from "./setPeppol.vue?vue&type=script&lang=js"
export * from "./setPeppol.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__